import { PagedRequestType, PagedResultsType } from "../../../types/PagedResults";
import { get } from "../../../utils/axios-config";
import { COURSES } from "../../../utils/constants";
import { CourseType } from "../../../types/Course";

export const getCourses = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.Id ? { Id: data.Id } : {}),
        ...(data?.IdDepartament ? { IdDepartament: data.IdDepartament } : {}),
        ...(data?.SearchTerm  ? { SearchTerm: data.SearchTerm } : {}),
         ...(data?.CourseLevel  ? { Level: data.CourseLevel } : {}),
    });
    const url = `${COURSES}?${queryParams.toString()}`;
    return await get<PagedResultsType<CourseType>>(url)
};
